import { useVh } from './ViewHeight.hooks';

export const ViewHeight = () => {
  const vh = useVh();

  return (
    <style>
      {`:root {
        --1vh: ${vh};
        --100vh: calc(var(--1vh, 1vh) * 100);
      }`}
    </style>
  );
};
